import React, { useRef, useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import {
	parseDateDesktop,
	parseDateDesktopMonth,
	parseEntities,
	today,
	getNextMonday,
	getNextMonth,
} from '../../utils/helpers';
import { FilterIcon, CloseIcon, ArrowIcon } from '../../../eagerlyIcons/src/__generated__/icons';

const FilterBarFlint = ({
  activeFilterDate,
  activeTimestamp,
  activeCinema,
  activeTags,
  availableDates,
  availableDatesMonths,
  availableCinema,
  availableTags,
  currentConfig,
  showFilters,
  handleFilter,
  handleRange,
  dateRange,
  rootElement,
}) => {
	const ref = useRef(),
	[isSticky, setIsSticky] = useState(false),
	[rootMargin, setRootMargin] = useState(0);

  const closeFilterDropdowns = (e) => {
    if (!e.target.classList.contains("custom-select") && e.target.closest(".custom-select") == null) {
      rootElement.removeEventListener("mousedown", closeFilterDropdowns);
      rootElement.querySelectorAll(".js_react_filter .custom-select__trigger").forEach((element) => {
        element.setAttribute("aria-expanded", "false");
      });
    }
  };

  const toggleSelectList = (e) => {
    if (e.target.tagName.toLowerCase() === "li" || e.target.tagName.toLowerCase() === "ul") {
      return;
    }
    rootElement.removeEventListener("mousedown", closeFilterDropdowns);
    rootElement.addEventListener("mousedown", closeFilterDropdowns);
    rootElement.querySelectorAll(".js_react_filter .custom-select__trigger").forEach((element) => {
      if (e.currentTarget.contains(element)) {
        element.setAttribute("aria-expanded", element.getAttribute("aria-expanded") == "true" ? "false" : "true");
      } else {
        element.setAttribute("aria-expanded", "false");
      }
    });
  };

  const buttonLabelCinema = () => {
    if (activeCinema.length === 0) return `${customData.i18n.agenda_filter_choose} ${customData.i18n.agenda_cinema_name}`; //kies bioscoop
    if (activeCinema.length === availableCinema.length) return customData.i18n.agenda_cinema_all; //Alle bioscopen
    return activeCinema.join(", ");
  };

  const buttonLabelTags = () => {
    if (activeTags.length === 0) return `${customData.i18n.agenda_filter_choose} ${customData.i18n.agenda_tag_filter_name}`; //kies filter
    if (activeTags.length === availableTags.length) return customData.i18n.agenda_tag_filter_all; //alle filters
    if (activeTags.length === 1) return parseEntities(activeTags[0]);
    return `${activeTags.length} ${customData.i18n.agenda_tag_filter_selected}`;
  };

  const getPosition = (filterOption) => {
    if (showFilters[0] === filterOption && showFilters[showFilters.length - 1] === filterOption) {
      return "first last";
    } else if (showFilters[0] === filterOption) {
      return "first";
    } else if (showFilters[showFilters.length - 1] === filterOption) {
      return "last";
    }
  };

   // const calcRootMargin = () => {
	// 	setRootMargin(
	// 		window
	// 		.getComputedStyle(document.body)
	// 		.getPropertyValue("--header-height")
	// 		.replace(/[^\d.]/g, "") *
	// 		parseFloat(getComputedStyle(document.documentElement).fontSize) +
	// 		2
	// 	);
	// };

	// useEffect(() => {
	// 	calcRootMargin();
	// 	window.addEventListener("resize", calcRootMargin);

	// 	const cachedRef = ref.current,
	// 		observer = new IntersectionObserver(
	// 		([e]) => {
	// 			setIsSticky(e.intersectionRatio < 1);
	// 		},
	// 		{
	// 			threshold: [1],
	// 			rootMargin: `-${rootMargin}px 0px 0px 0px`, // alternativly, use this and set `top:0` in the CSS
	// 		}
	// 		);
	// 	observer.observe(cachedRef);

	// 	// unmount
	// 	return function () {
	// 		observer.unobserve(cachedRef);
	// 		window.removeEventListener("resize", calcRootMargin);
	// 	};
	// }, [rootMargin]);

  return (
    <>
      <h2>
        Flint <span>Agenda</span>
      </h2>

      <div className={`filter-bar filter-bar__tablet sticky show@for-tablet-l-up ${isSticky ? ' isSticky' : ''}`}>
        <div className="filter-bar__options">
          {showFilters.includes('date') && (
            <div className={`custom-select ${getPosition('date')}`} onClick={(e) => toggleSelectList(e)}>
              <button className="custom-select__trigger has-selected js-date-button " aria-haspopup="listbox" aria-labelledby="date_label date_button" aria-expanded="false" id="date_button">
                <div className="custom-select__label" id="date_label">
                  <span className="sr-only">`${customData.i18n.agenda_filter_choose} `</span>
                  {customData.i18n.agenda_date_name}
                </div>
                {/* {activeFilterDate ? parseDateDesktop(activeTimestamp) : customData.i18n.agenda_date_all} */}
                <DatePicker
                  selected={activeTimestamp}
                  onChange={(date) => handleFilter('filterDate', date.getTime())}
                  showIcon
                  todayButton={customData.i18n.agenda_date_today}
                  includeDates={availableDates.map((date, index) => {
                    if (date >= today) {
                      return date;
                    }
                  })}
                />
              </button>
            </div>
          )}

          {showFilters.includes('tags') && (
            <div className={`custom-select ${getPosition('tags')}`} onClick={(e) => toggleSelectList(e)}>
              <button
                className={`custom-select__trigger ${activeTags.length !== 0 ? 'has-selected' : ''}`}
                aria-haspopup="listbox"
                aria-labelledby="bioscoop_label"
                aria-expanded="false"
                id="bioscoop_button"
              >
                <div className="custom-select__label" id="bioscoop_label">
                  <span className="sr-only">`${customData.i18n.agenda_filter_choose} `</span>
                  {customData.i18n.agenda_tag_filter_name}
                </div>
                {buttonLabelTags()}
              </button>
              <ul className="listbox  listbox--multi  listbox--multi" role="listbox" aria-labelledby="tags_label" aria-multiselectable="true" aria-activedescendant="">
                {availableTags.map((tag, index) =>
                  currentConfig.tags_hide_from_dropdown.includes(tag) ? (
                    ''
                  ) : (
                    <li onClick={() => handleFilter('filterTags', tag, false)} role="option" id="date_000" aria-selected={activeTags.includes(tag) ? 'true' : 'false'} data-value={tag} key={index}>
                      {parseEntities(tag)}
                    </li>
                  )
                )}
              </ul>
            </div>
          )}

          {showFilters.includes('cinema') && (
            <div className={`custom-select ${getPosition('cinema')}`} onClick={(e) => toggleSelectList(e)}>
              <button
                className={`custom-select__trigger ${activeCinema.length !== 0 ? 'has-selected' : ''}`}
                aria-haspopup="listbox"
                aria-labelledby="bioscoop_label"
                aria-expanded="false"
                id="bioscoop_button"
              >
                <div className="custom-select__label" id="bioscoop_label">
                  <span className="sr-only">`${customData.i18n.agenda_filter_choose} `</span>
                  {customData.i18n.agenda_cinema_name}
                </div>
                {buttonLabelCinema()}
              </button>
              <ul className="listbox listbox--multi listbox--multi-cinema" role="listbox" aria-labelledby="bioscoop_label" aria-multiselectable="true" aria-activedescendant="">
                {availableCinema.map((cinemaOption, index) => (
                  <li
                    onClick={() => handleFilter('filterCinema', cinemaOption)}
                    role="option"
                    id="date_000"
                    aria-selected={activeCinema.includes(cinemaOption) ? 'true' : 'false'}
                    data-value={cinemaOption}
                    key={index}
                    data-cinema_id={cinemaOption}
                  >
                    {cinemaOption}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
        <button onClick={() => handleFilter('resetFilters', null)} className="filter-bar__reset">
          <span className="hide-non-desktop">{customData.i18n.agenda_delete_filters}</span>
        </button>
      </div>
    </>
  );
};

export default FilterBarFlint;
